var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAnomaly(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_anomaly",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "base",
    width: 24,
    height: 24,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "anomaly",
    d: "M9.012,19.024a3.7,3.7,0,1,1,3.7-3.7A3.708,3.708,0,0,1,9.012,19.024Zm0-5.407a1.7,1.7,0,1,0,1.7,1.7A1.705,1.705,0,0,0,9.012,13.617Zm6.309-.9a3.7,3.7,0,1,1,3.7-3.7A3.708,3.708,0,0,1,15.32,12.715Zm0-5.407a1.7,1.7,0,1,0,1.7,1.7A1.705,1.705,0,0,0,15.32,7.309ZM2.7,12.715a3.7,3.7,0,1,1,3.7-3.7A3.708,3.708,0,0,1,2.7,12.715Zm0-5.407a1.7,1.7,0,1,0,1.7,1.7A1.705,1.705,0,0,0,2.7,7.309Zm6.309-.9a3.7,3.7,0,1,1,3.7-3.7A3.708,3.708,0,0,1,9.012,6.407ZM9.012,1a1.7,1.7,0,1,0,1.7,1.7A1.705,1.705,0,0,0,9.012,1Z",
    transform: "translate(2.988 2.988)",
    fill: "#222a41"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnomaly);
export default __webpack_public_path__ + "static/media/icon_anomaly.70bea5a6.svg";
export { ForwardRef as ReactComponent };